.root {
  --color-change-button-size: 100%;
}
